<template>
	<div class="pt-2">
		<CommonFlame :title="title">
			<div class="mt-2">
				<h6 class="font-weight-bold text-h6">
					工事期間：{{ constructionStart() }}~{{ constructionEnd() }}
				</h6>
			</div>
			<div class="table-container mt-4">
				<v-data-table
					locale="ja-JP"
					:items="schedules"
					:headers="headers"
					:mobile-breakpoint="240"
					hide-default-footer
					disable-filtering
					disable-pagination
					disable-sort
					no-data-text="データがありません。"
				>
					<template v-slot:item="{ item }">
						<tr @click="openShowDialog(item.id)">
							<td>{{ item.customer_company.name }}</td>
							<td>{{ item.construction.name }}</td>
							<td>{{ item.product_number }}</td>
							<td>{{ common.formatDate(item.date) }}</td>
							<td>{{ item.user.full_name }}</td>
						</tr>
					</template>
				</v-data-table>
			</div>
			<PaginationModule :pagination="pagination" @get-page="getPage(fetchSchedules, [], $event)" />
		</CommonFlame>
		<ConstructionScheduleShowDialog
			:id="selectedId"
			:dialog.sync="dialog"
			@update-schedule="updateSchedule($event)"
		/>
	</div>
</template>

<script>
import axios from "axios"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import common from "../../helper/common"
import paginationMixin from "../../helper/paginationMixin"
import CommonFlame from "../shared/CommonFlame.vue"
import ConstructionScheduleShowDialog from "./components/ConstructionScheduleShowDialog.vue"

export default {
	mixins: [paginationMixin],
	components: {
		CommonFlame,
		ConstructionScheduleShowDialog,
	},
	data() {
		return {
			title: "作業日報一覧",
			schedules: [],
			authority_flag: false,
			headers: headers(),
			selectedId: null,
			dialog: false,
			common,
		}
	},

	mounted() {
		const page = this.$route.query.page ? this.$route.query.page : 1
		this.setQuery()
		// this.fetchSchedules(page, true)

		this.schedules = [...Array(5)].map((_, i) => {
			return {
				customer_company: { name: "XXXXXXX" },
				construction: { name: "XXXXXXX" },
				product_number: "2023XXXXXX",
				date: `2023-01-0${i + 1}`,
				user: { full_name: "XX XX" },
			}
		})
		this.schedules = this.schedules.concat(
			[...Array(4)].map((_, i) => {
				return {
					customer_company: { name: "XXXXXXX" },
					construction: { name: "XXXXXXX" },
					product_number: "2023XXXXXX",
					date: `2023-01-0${i + 6}`,
					user: { full_name: "" },
				}
			})
		)
	},
	methods: {
		fetchSchedules(page, first_visit = false) {
			const headers = authenticate.setHeader()
			const params = { page, first_visit }
			axios
				.get("/erp/v1/schedules", {
					params,
					headers,
				})
				.then((res) => {
					this.schedules = res.data.schedules
					this.pagination = res.data.pagination
					// 初回のアクセスのみデータを取得する
					if (first_visit) {
						this.authority_flag = res.data.authority_flag
					}
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		updateSchedule(schedule) {
			// TODO
		},
		constructionStart() {
			// TODO
      return "2023/01/01"
		},
		constructionEnd() {
      // TODO
      return "2023/01/09"
		},
		openShowDialog(id) {
			this.dialog = true
			this.selectedId = id
		},
	},
}

function headers() {
	return [
		{ text: "顧客名", value: "customer_company.name", width: "200px" },
		{ text: "工事名", value: "construction.name", width: "200px" },
		{ text: "製番", value: "product_number", width: "200px" },
		{ text: "日付", value: "date", width: "120px" },
		{ text: "記入者", value: "user.full_name", width: "120px" },
	]
}
</script>
